<template>
    <div class="number-field" v-bind:class="inputSize">
        <div class="flex-center">
            <div class="subtract" v-bind:class="{ disabled : inputValue <= inputMin }" @mousedown="decrease" @mouseup="stopInterval">
                <span class="material-icons">remove_circle_outline</span>
            </div>
            <div class="field">
                <input autocomplete="off" @keyup="checkValue" v-bind:class="{ required : isRequired, zero : inputValue == 0  }" type="text" v-bind:name="inputName" v-model="inputValue" />
            </div>
            <div class="add" v-bind:class="{ disabled : inputValue >= inputMax }" @mousedown="increase" @mouseup="stopInterval">
                <span class="material-icons">add_circle_outline</span>
            </div>
        </div>
    </div>
</template>

<script>
    module.exports = {
        created: function () {
            if(this.name != undefined) {
                this.inputName = this.name;
            }
            if(this.max != undefined && this.max != '') {
                this.inputMax = parseFloat(this.max);
            }
            if(this.min != undefined && this.min != '') {
                this.inputMin = parseFloat(this.min);
            }
            if(this.value != undefined && this.value != '') {
                this.inputValue = parseFloat(this.value);
            } else {
                this.inputValue = this.inputMin;
            }
            if(this.required != undefined) {
                this.isRequired = true;
            }
            if(this.step != undefined) {
                this.inputStep = parseFloat(this.step);
            }
            if(this.size != undefined) {
                this.inputSize =  this.size;
            }
        },
        data:function() {
            return {
                inputInterval:false,
                inputIntervalSpeed:300,
                inputName:'',
                inputValue:0,
                inputMin:1,
                inputMax:100,
                inputSize:'',
                inputStep:1,
                isRequired:false
            }
        },
        props:['name','value','min','max','required','size','step'],
        methods: {
            stopInterval:function() {
                clearTimeout(this.inputInterval);
                this.inputIntervalSpeed = 300;
            },
            increase:function() {
                this.inputValue = parseFloat(this.inputValue);
                this.inputValue += this.inputStep;
                if(this.inputValue > this.inputMax) {
                    this.inputValue =  this.inputMax;
                }
                var e = this;
                e.inputIntervalSpeed -= 30;
                if(e.inputIntervalSpeed < 50) {
                    e.inputIntervalSpeed = 50;
                }
                e.inputInterval = setTimeout(function() {
                    e.increase();
                },e.inputIntervalSpeed);
            },
            decrease:function() {
                this.inputValue = parseFloat(this.inputValue);
                this.inputValue -= this.inputStep;
                if(this.inputValue < this.inputMin) {
                    this.inputValue = this.inputMin;
                }
                var e = this;
                e.inputIntervalSpeed -= 30;
                if(e.inputIntervalSpeed < 50) {
                    e.inputIntervalSpeed = 50;
                }
                e.inputInterval = setTimeout(function() {
                    e.decrease();
                },e.inputIntervalSpeed);
            },
            checkValue:function() {
                if(this.inputValue < this.inputMin) {
                    this.inputValue = this.inputMin;
                } else if(this.inputValue > this.inputMax) {
                    this.inputValue = this.inputMax;
                }
            }
        },
        mounted:function() {

        }
    }
</script>

